import { render } from "./Pagination.vue?vue&type=template&id=328b4798"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\yiren\\OneDrive\\桌面\\The F2E\\TaiwanTourism\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__